import { ClaimClosureStatus, Maybe } from "generated/graphql";
import { hv } from "Tools";

export function getCaseStatus(appCase: { closedOn?: Maybe<Date> }) {
  return hv(appCase?.closedOn) ? "Closed" : "Open";
}

export function getClaimStatus(claim: {
  closedOn?: Maybe<Date>;
  closureStatus?: Maybe<ClaimClosureStatus>;
}) {
  return !hv(claim.closedOn)
    ? "Under Review"
    : claim.closureStatus === ClaimClosureStatus.PAID
    ? "Paid"
    : "Denied";
}
